if ($('.sidebar.sidebar-left').length) {
    $('.sidebar.sidebar-left').append($('#footer .reviewsWrap').clone());
    $('.sidebar.sidebar-left').append($('.sidebar-inner .banner').clone());
    $('.sidebar.sidebar-left').append($('#footer .reviewsWrap .payments').clone());
}
